import { useState } from "react";
import { apiURL } from "../../consts/URLs";
import { GET_LOCATIONS, LOCATIONS } from "../endpointList";
import { fetchRequest, getOptions } from "../utils";
import { getCookie } from "../../utils/handleCookie";
import { cookieName } from "../../consts/cookie";

const token = getCookie(cookieName.token);

const useLocations = () => {
  const [getListAllResponse, setListAllResponse] = useState<any>();
  const [getListAllResult, setListAllResult] = useState<any>();
  const [createLocationResponse, setCreateLocationResponse] = useState<any>();
  const [createLocationResult, setCreateLocationResult] = useState<any>();
  const [updateLocationResponse, setUpdateLocationResponse] = useState<any>();
  const [updateLocationResult, setUpdateLocationResult] = useState<any>();
  const [deleteLocationResponse, setDeleteLocationResponse] = useState<any>();
  const [deleteLocationResult, setDeleteLocationResult] = useState<any>();

  const getListAll = (model_id: number) => {
    const url = `${apiURL}/${GET_LOCATIONS}/${model_id}`;
    const options = getOptions({ method: "GET", token: token });
    fetchRequest(url, options, setListAllResponse, setListAllResult);
  };

  const createLocation = (obj: any) => {
    const url = `${apiURL}/${LOCATIONS}`;
    const options = getOptions({
      method: "POST",
      body: { ...obj },
      token: token,
    });
    fetchRequest(
      url,
      options,
      setCreateLocationResponse,
      setCreateLocationResult
    );
  };

  const updateLocation = (location_id: number, obj: any) => {
    const url = `${apiURL}/${LOCATIONS}/${location_id}`;
    const options = getOptions({
      method: "PUT",
      body: { ...obj },
      token: token,
    });
    fetchRequest(
      url,
      options,
      setUpdateLocationResponse,
      setUpdateLocationResult
    );
  };

  const deleteLocation = (id: number) => {
    const url = `${apiURL}/${LOCATIONS}/${id}`;
    const options = getOptions({ method: "DELETE", token: token });
    fetchRequest(
      url,
      options,
      setDeleteLocationResponse,
      setDeleteLocationResult
    );
  };

  const RESPONSES = {
    getListAllResponse,
    createLocationResponse,
    updateLocationResponse,
    deleteLocationResponse,
  };

  const RESULTS = {
    getListAllResult,
    createLocationResult,
    updateLocationResult,
    deleteLocationResult,
  };

  const CTAs = {
    getListAll,
    createLocation,
    updateLocation,
    deleteLocation,
  };

  return { RESPONSES, RESULTS, CTAs };
};
export default useLocations;
